import script from "./YaleCase.vue?vue&type=script&setup=true&lang=js"
export * from "./YaleCase.vue?vue&type=script&setup=true&lang=js"

import "./YaleCase.vue?vue&type=style&index=0&id=b269da08&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b269da08"]])

export default __exports__